/**
 * These are configuration settings for the production environment.
 *
 * Do not include API secrets in this file or anywhere in your JS.
 *
 * https://reactnative.dev/docs/security#storing-sensitive-info
 */
export default {
  DEFAULT_AUTH_HOST: "prod.auth.sidekickplatform.com",
  BACKEND_API_VERSION: "0.1.8",
}
